<template>
  <div class="mains">
    <div class="campus">
      教务管理
      <span>></span>
      <router-link to="campus">分校区管理</router-link>
      <span>></span>新建校区
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="xiaoqu_1">新建校区</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i>请您慎重选择首次信息填写内容，因部分信息内容不可再次修改。
        </div>
        <div class="form_1">
          <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
            <el-form-item label="校区名称" prop="name">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.name" placeholder="请输入校区名称 ( 不超过12字 )"></el-input>
            </el-form-item>
            <el-form-item label="校区代码" prop="orgcode">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.orgcode" placeholder="请您输入校区代码"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="tel">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.tel" placeholder="请您输入固定联系号码，以便联系"></el-input>
            </el-form-item>
            <el-form-item label="校区邮箱" prop="email">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.email" placeholder="请您输入校区邮箱"></el-input>
            </el-form-item>
            <el-form-item label="校区校长" prop="headmaster">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.headmaster" placeholder="请输入校区校长名字"></el-input>
            </el-form-item>
            <el-form-item label="校长联系方式" prop="headmaster_tel" class="xiaozhang000">
              <i>
                <img class="xiaozhang" src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.headmaster_tel" placeholder="请输入校区校长联系方式"></el-input>
            </el-form-item>
            <el-form-item label="校长个人邮箱" prop="headmaster_mail" class="xiaozhang000">
              <i>
                <img class="xiaozhang" src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.headmaster_mail" placeholder="请输入校区校长的个人邮箱"></el-input>
            </el-form-item>
            <el-form-item label="校区地址" prop="address">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange" placeholder="请选择您所在的城市" class="dizhi"></el-cascader>
              <span class="hengxian">—</span>
              <el-input class="xiangxi" v-model="form.address" placeholder="您可自由填写校区具体地址"></el-input>
            </el-form-item>

            <el-form-item label="校区描述" style="margin-top: -40px">
              <i class="ziyou">
                <img src="@/assets/img/education-manage/campus/ziyou.png" alt />
              </i>
              <el-input type="textarea" v-model="form.description" placeholder="可自由输入校区简介"></el-input>
            </el-form-item>
            <!--
            <el-form-item label="是否同步">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-radio-group v-model="form.syn_data">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
              <div style="
                  float: right;
                  margin-right: 65%;
                  color: #ccc;
                  font-size: 0.83333vw;
                ">
                是否选择将主校区的教材同步到分校区
              </div>
            </el-form-item>
            -->
            <el-form-item label="校区LOGO">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" style="left: -5vw; top: 0.78125vw" alt />
              </i>
              <el-upload class="avatar-uploader el-upload__tip0" action style="margin-left: 10px" :show-file-list="false">
                <img v-if="accountForm.photo.icon" :src="accountForm.photo.icon" class="avatar" width="140" height="140" />
                <el-button size="small" type="primary" class="genghuan">更换图片</el-button>
                <div slot="tip" class="el-upload__tip">
                  <span>( 建议：JPG或PNG图片， 推荐：400*400)</span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item class="tijiao">
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <router-link to="campus">
                <el-button>取消</el-button>
              </router-link>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
// CodeToText
import { regionDataPlus } from 'element-china-area-data';
export default {
  name: 'campusnew',
  data() {
    return {
      form: {
        name: '',
        orgcode: '',
        tel: '',
        email: '',
        headmaster: '',
        headmaster_tel: '',
        headmaster_mail: '',
        province: '',
        city: '',
        district: '',
        address: '',
        description: '',
        syn_data: '1',
      },
      FormRules: {
        name: [{ required: true, message: '请您填写必填信息' }],
        orgcode: [{ required: true, message: '请您填写必填信息' }],
        tel: [
          { required: true, message: '请您填写必填信息' },
          { pattern: /^1[35789]\d{9}$/, message: '账号格式不对' },
        ],
        email: [{ required: true, message: '请您填写必填信息' }],
        headmaster: [{ required: true, message: '请您填写必填信息' }],
        headmaster_tel: [
          { required: true, message: '请您填写必填信息' },
          { pattern: /^1[35789]\d{9}$/, message: '账号格式不对' },
        ],
        headmaster_mail: [{ required: true, message: '请您填写必填信息' }],
        syn_data: [{ required: true, message: '请您填写必填信息' }],
        address: [{ required: true, message: '请您填写必填信息' }],
      },
      accountForm: {
        photo: {
          icon: require('@/assets/img/education-manage/campus/logo.png'),
        },
      },
      options: regionDataPlus,
      selectedOptions: [],
    };
  },
  methods: {
    onSubmit() {
      this.$refs.forms.validate((valid) => {
        if (!valid) {
          return false;
        }
        // console.log(valid)
        var that = this.form;
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let orgid = window.sessionStorage.getItem('orgid');
        let pro = this.$http({
          url: '/edu/org/addOrg',
          method: 'POST',
          data: { name: that.name, orgcode: that.orgcode, tel: that.tel, email: that.email, headmaster: that.headmaster, headmaster_tel: that.headmaster_tel, headmaster_mail: that.headmaster_mail, province: this.province, city: this.city, district: this.district, address: that.address, description: that.description, syn_data: that.syn_data, parentid: orgid },
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.$router.push({ name: 'campus' });
          })
          .catch((err) => {
            // console.log(err)
            return this.$message.error('新建校区失败：' + err);
          });
      });
    },
    handleChange(value) {
      // console.log(value)
      for (var i = 0; i < value.length; i++) {
        // console.log(CodeToText[value[i]])
        this.province = value[0];
        this.city = value[1];
        this.district = value[2];
      }
      // console.log(this.province, this.city, this.district)
    },
  },
};
</script>

<style lang="less">
.mains {
  .campus {
    // width: 28px;
    // height: 20px;
    font-family: PingFang SC;
    font-size: 14px;
    color: #666666ff;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 10px;
    span {
      margin: 0 10px 0 8px;
    }
  }
  .el-card__body {
    padding: 0;
  }
  .el-card {
    .xiaoqu_1 {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 18px;
      color: rgba(51, 51, 51, 1);
      letter-spacing: 1px;
      border-left: 3px solid #0090c9;
      padding-left: 12px;
      position: relative;
      top: 5px;
      // left: 5px;
      margin: 20px 0 20px 30px !important;
    }
    .shenzhong {
      background: rgba(246, 98, 0, 0.1) !important;
      margin-top: 25px;
      height: 40px;
      line-height: 40px;
      color: #f66200 !important;
      font-size: 14px;
      padding-left: 63px;
      margin-bottom: 43px;
      .img_1 {
        position: relative;
        img {
          position: absolute;
          top: 2px;
          left: -20px;
        }
      }
    }
    .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
      content: '';
    }
    .form_1 {
      margin-left: 255px;
      .el-form-item__error {
        margin-left: 24px;
      }
      input {
        width: 560px;
        height: 36px;
        margin-left: 18px;
      }
      .el-radio-group {
        margin-left: 18px;
      }
      .el-textarea__inner {
        width: 560px;
        height: 80px;
        margin-left: 18px;
        resize: none;
        font-size: 14px;
        font-weight: 550;
      }
      .el-input__inner {
        padding-left: 20px;
      }
      .xiaozhang000 {
        .el-form-item__label {
          width: 113px !important;
          margin-left: -14px;
        }
      }
      .el-form-item {
        margin-bottom: 25px;
        .xiaozhang {
          margin-left: -35px;
        }
        .ziyou {
          img {
            margin-top: -40px;
          }
        }
        i {
          position: relative;
          img {
            position: absolute;
            top: 5px;
            left: -85px;
            float: left;
            margin-left: -6px;
          }
        }
        .el-button--primary {
          width: 240px;
          height: 46px;
          font-size: 20px;
          margin-left: 18px;
          font-weight: 500;
          background: rgba(0, 166, 230, 1);
          box-shadow: 2px 2px 6px rgba(0, 148, 206, 0.3);
          opacity: 1;
          border-radius: 34px;
        }
        .el-button--default {
          width: 240px;
          height: 46px;
          font-size: 20px;
          margin-left: 18px;
          font-weight: 500;
          border: none;
          color: #999999;
          background: rgba(234, 234, 234, 1);
          box-shadow: 2px 2px 6px rgba(234, 234, 234, 0.3);
          opacity: 1;
          border-radius: 34px;
          margin-left: 50px;
        }
        .dizhi {
          input {
            width: 300px;
          }
        }
        .hengxian {
          color: #ccc;
          margin-left: 12px;
        }
        .xiangxi {
          position: relative;
          input {
            width: 220px;
            position: absolute;
            top: -63px;
            left: 340px;
          }
        }
        .genghuan {
          width: 85px;
          height: 28px;
          font-size: 14px;
          line-height: 10px;
          border-radius: 17px;
          float: right;
          margin: 43% 0 0 0;
        }
        .el-upload__tip {
          float: right;
          color: #ccc;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
